<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Chức vụ" prop="title">
        <a-select
          placeholder="- Chọn chức vụ -"
          style="width: 100%;"
          v-model="form.title"
        >
          <a-select-option value="DRAFTERS">
            Người soạn thảo
          </a-select-option>
          <a-select-option value="DRAFTMANAGER">
            Trưởng phòng văn thư
          </a-select-option>
          <a-select-option value="BOD">
            Ban giám đốc
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item has-feedback label="Người dùng" prop="usersIds">
        <SelectUser
          v-model="form.usersIds"
          :selectProps="{
            mode: 'multiple',
            placeholder: '- Chọn người dùng -',
            value: form.usersIds,
          }"
        />
      </a-form-model-item>
    </a-form-model>

    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin: 0 5px;" @click="closeDrawerAdd">
        Đóng
      </a-button>
      <a-button
        type="primary"
        @click="saveDocumentConfig"
        :loading="loadingButton"
      >
        Thêm mới
      </a-button>
    </div>
  </div>
</template>
<script>
import SelectUser from "@/components/common/user/select";
import postQuery from "../data/postData";
export default {
  props: {
    addDocumentConfigOnView: {
      type: Function,
      default: null,
    },
    closeDrawerAdd: {
      type: Function,
      default: null,
    },
  },
  components: {
    SelectUser,
  },

  data() {
    return {
      form: {
        title: undefined,
        usersIds: undefined,
      },
      loadingButton: false,
      rules: {
        title: [
          {
            required: true,
            message: "Chức vụ không được bỏ trống",
            trigger: "change",
          },
        ],
        usersIds: [
          {
            required: true,
            message: "Người dùng không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    saveDocumentConfig() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryCreateDocumentConfig,
              variables: {
                ...this.form,
              },
            })
            .then(({ data }) => {
              if (data?.createDocumentConfig) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Cấu hình người dùng thành công !",
                });
                this.addDocumentConfigOnView(data.createDocumentConfig);
                this.closeDrawerAdd();
              }
              this.loadingButton = false;
            })
            .catch(() => {
              this.$notification.error({
                message: "Thông báo",
                description: "Chức vụ đã được chọn",
              });
              this.loadingButton = false;
            });
        }
      });
    },
  },
};
</script>
<style></style>
